// Admin Analytics Action Types

// Fetch all students' progress data
export const FETCH_ADMIN_ANALYTICS_REQUEST = 'FETCH_ADMIN_ANALYTICS_REQUEST';
export const FETCH_ADMIN_ANALYTICS_SUCCESS = 'FETCH_ADMIN_ANALYTICS_SUCCESS';
export const FETCH_ADMIN_ANALYTICS_FAILURE = 'FETCH_ADMIN_ANALYTICS_FAILURE';

// Fetch question-level analytics
export const FETCH_QUESTION_ANALYTICS_REQUEST = 'FETCH_QUESTION_ANALYTICS_REQUEST';
export const FETCH_QUESTION_ANALYTICS_SUCCESS = 'FETCH_QUESTION_ANALYTICS_SUCCESS';
export const FETCH_QUESTION_ANALYTICS_FAILURE = 'FETCH_QUESTION_ANALYTICS_FAILURE';

// Fetch individual student details
export const FETCH_STUDENT_DETAILS_REQUEST = 'FETCH_STUDENT_DETAILS_REQUEST';
export const FETCH_STUDENT_DETAILS_SUCCESS = 'FETCH_STUDENT_DETAILS_SUCCESS';
export const FETCH_STUDENT_DETAILS_FAILURE = 'FETCH_STUDENT_DETAILS_FAILURE';

// Clear analytics data
export const CLEAR_ADMIN_ANALYTICS = 'CLEAR_ADMIN_ANALYTICS';
